module.exports = __webpack_public_path__ + "dist/media/ec_comp_search.67c97bb5.svg";